import React from 'react';

import ListItem from '../ListItem/ListItem';
import './style.scss';

const List = (props) => {
  const { items, children, deleteItem, calculateBalance } = props;

  return (
    <div className={children.toLowerCase()}>
      <h2>{children}</h2>
      <ul className='list'>
        {!items || items.length !== 0 ? items.map((item, index) => (
        <ListItem
          key={`id-${index}`}
          deleteItem={deleteItem}
          title={item.title}
          category={item.category}
          amount={item.amount}
          type={item.type}
          id={item.id}
          calculateBalance={calculateBalance}
        />
      )) : '(silence is golden)' }
      {/* )) : '(silence is golden)' } */}
      </ul>
    </div>
  );
};

export default List;
